<div class="position-day-wks-component" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <span>{{ title }}</span>
    <div class="help-icon">
      <mat-icon class="pointer float-left" svgIcon="help" #tooltipMin="matTooltip"
        matTooltipPosition="above" [matTooltip]="positionDayHelpText"></mat-icon>
    </div>
    <div *ngIf="account" class="mat-title" [matMenuTriggerFor]="wks" matTooltipPosition="above" matTooltip="Selecionar visão">
      <mat-form-field>
        <input readonly matInput [value]="activeView?.title || 'Aguarde...'">
        <mat-icon matSuffix class="icon-arrow" svgIcon="arrow-down"></mat-icon>
      </mat-form-field>
    </div>
    <mat-menu class="custom-mat-menu worksheet mat-btn-wkst" #wks="matMenu" [overlapTrigger]="false">
      <mat-list *ngFor="let view of views">
        <mat-list-item [ngClass]="{'selected' : view.type === activeView?.type}" (click)="setGridView(view)">
          <span>{{ view.title }}</span>
        </mat-list-item>
      </mat-list>
    </mat-menu>
    <div class="icons gridster-ignore-drag">
      <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon disableWksChange *ngIf="!newWindow" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <app-spinner-loading *ngIf="loading"></app-spinner-loading>
  <div *ngIf="!loading" class="component-container gridster-ignore-drag">
    <div class="row row-content">
      <div class="col-12 p-0">
        <div *ngIf="!account" class="not-logged-div">
          <span>{{msgOfflineNegotiation}}</span>
        </div>
        <ng-container *ngIf="account">
          <div class="row m-0 financial-info">
            <div class="col">
              <div class="float-left mr-2">
                <span>L/P Aberto : </span>
                <span class="values"
                  [ngClass]="financialInfo.lucroPrejuizoOpen == 0 ? '': financialInfo.lucroPrejuizoOpen > 0 ? 'positive-value':'negative-value'">{{financialInfo.lucroPrejuizoOpenFormated | currency:'BRL':'symbol':'1.2-2':'pt'}}</span>
              </div>
              <div class="float-left mr-2">
                <span>L/P Fechado : </span>
                <span class="values"
                  [ngClass]="financialInfo.lucroPrejuizoClose == 0 ? '': financialInfo.lucroPrejuizoClose > 0 ? 'positive-value':'negative-value'">{{financialInfo.lucroPrejuizoCloseFormated | currency:'BRL':'symbol':'1.2-2':'pt'}}</span>
              </div>
              <div class="float-left">
                <span>L/P Total : </span>
                <span class="values"
                  [ngClass]="financialInfo.lucroPrejuizoTotal == 0 ? '': financialInfo.lucroPrejuizoTotal > 0 ? 'positive-value':'negative-value'">{{financialInfo.lucroPrejuizoTotalFormated | currency:'BRL':'symbol':'1.2-2':'pt'}}</span>
              </div>
            </div>
          </div>
          <!-- TODO: Desabilitado opção de selecionar e limpar posições em lote -->
          <!-- <div class="action-div" [ngClass]="{'show': checkedItems || checkIndeterminate}">
            <div class="row row-action">
              <div class="col col-data-remove">
                <mat-checkbox class="chk-delete" [(ngModel)]="checkedItems" [(indeterminate)]="checkIndeterminate"
                  labelPosition="after" (change)="changeCheck($event)">
                  {{lengthChecked + (lengthChecked > 1 ? ' ATIVOS SELECIONADOS' : ' ATIVO SELECIONADO')}}
                </mat-checkbox>
              </div>
              <div class="col-3 action-btn btn-rem" (click)="verifySelectedPositionsToReset()">
                <mat-icon class="pointer delete-icon-white" svgIcon="delete-white"></mat-icon>
                {{(lengthChecked > 1 ? ' Zerar posições' : ' Zerar posição')}}
              </div>
            </div>
          </div>
          <ag-grid-angular #wksPosition style="width: 100%; height: 100%;" class="ag-theme-balham"
            [ngClass]="{'uncheck': !checkedItems && !checkIndeterminate}" [rowData]="rowDataPosition" [rowSelection]="rowSelection"
            [gridOptions]="gridOptionsPosition" (gridReady)="onGridReady($event)" [columnDefs]="activeColumnDefsPosition"
            (selectionChanged)="onSelectionChanged($event)" [suppressRowClickSelection]="true" [isRowSelectable]="isRowSelectable">
          </ag-grid-angular> -->
          <ag-grid-angular #wksPosition style="width: 100%; height: 100%;" class="ag-theme-balham" [rowData]="rowDataPosition"
            [columnDefs]="activeColumnDefsPosition" [gridOptions]="gridOptionsPosition" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div (window:beforeunload)="closeSheet()"></div>
